module.exports = __webpack_public_path__ + "static/img/icon-menu4.1a448a45.svg";